import script from "./GGanttTimeaxis.vue?vue&type=script&setup=true&lang=ts"
export * from "./GGanttTimeaxis.vue?vue&type=script&setup=true&lang=ts"

import "./GGanttTimeaxis.vue?vue&type=style&index=0&id=19067f4d&lang=css"

const __exports__ = script;

export default __exports__